import { action } from '@reatom/framework'

import {
  onInitializationReadyAction,
  onInitializationReadyOrWebsiteAction,
} from '@root/features/initialization/atoms/common'

import { initializeAlertsNotificationsAction } from './reatom-alerts-notifications'
import { loadTrackingWalletsReaction } from './reatom-tracking-wallets'
import { initializeTrackingWalletsAlertsReaction } from './reatom-tracking-wallets-alerts'
import { trackingWalletAlertsTableModel } from './reatom-tracking-wallets-alerts-table'

export const initializeWalletTrackerAction = action((ctx) => {
  trackingWalletAlertsTableModel.initializeSubscriptions(ctx)

  /**
   * The tracker is in the footer of every screen, so it starts with the app.
   *
   * It used to start only on `Ready`, which the browser never reaches: the
   * web session settles on `Website` instead, and `Ready` belongs to the
   * desktop build. So on the web the list was never fetched in the
   * background and **the socket was never subscribed to at all** — verified
   * on the deployed staging 2026-10-03, where the trade socket held eleven
   * rooms and not one of them a `wallets-tracker:` one, and a forced
   * reconnect re-subscribed pair prices, pool activity and the support
   * ticket while never mentioning the tracker.
   *
   * The panel was therefore empty until the tracker's own page was opened,
   * and then stayed as it was: nothing topped it up.
   *
   * The same mistake was found and fixed for `/me` once already; the note
   * beside the web branch in `initializeInitializationAction` records it.
   */
  onInitializationReadyOrWebsiteAction(ctx, () => {
    initializeTrackingWalletsAlertsReaction(ctx)
    loadTrackingWalletsReaction(ctx)
  })

  // Desktop notifications are Tauri's, and only the desktop build has them.
  onInitializationReadyAction(ctx, () => {
    initializeAlertsNotificationsAction(ctx)
  })
}, 'initializeWalletTrackerAction')
